// extracted by mini-css-extract-plugin
export var divider = "_fm-7";
export var itemsToggle = "_fm-8";
export var mergeModal = "_fm-1";
export var optionCard = "_fm-4";
export var radioGroup = "_fm-6";
export var radioOption = "_fm-0";
export var selected = "_fm-5";
export var shipmentOptions = "_fm-2";
export var tableOptions = "_fm-3";